import Vue from 'vue';

interface Modal extends HTMLElement {
  show(): void,
  hide(): void,
}

export default Vue.extend({
  methods: {
    show() {
      (this.$refs.modal as Modal).show();
    },
    hide() {
      (this.$refs.modal as Modal).hide();
    },
    onOKClick(payload: any) {
      this.$emit('ok', payload);
    },
  },
});
